export default __webpack_public_path__ + "static/media/ThingBackground.a339c469.png";